import { ActivatedRoute } from '@angular/router';

/**
 * Reads a route param, walking up the parent routes until one defines it.
 *
 * Angular's default `paramsInheritanceStrategy` ('emptyOnly') only passes a parent's params
 * down to a child when the parent is componentless or has an empty path. A parent route that
 * hosts a component under a non-empty path (e.g. `monitoring` → MonitoringLayoutComponent)
 * therefore hides ancestors' params such as `:project` from its children — so a child page
 * must look them up the tree instead of reading `route.snapshot.params`.
 */
export function findRouteParam(route: ActivatedRoute, name: string): string | null {
  let r: ActivatedRoute | null = route;
  while (r) {
    const value = r.snapshot.paramMap.get(name);
    if (value) return value;
    r = r.parent;
  }
  return null;
}
